import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useLogoutAllOtherSessions() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: () => del({ url: '/user/account/sessions/logout-all-other' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getSessions });
    },
  });

  const logoutAllOther = useCallback(() => mutate(), [mutate]);

  return { logoutAllOther, error, isPending, isSuccess, reset };
}
